{
  "name": "awisa-gui",
  "version": "1.11.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --ssl true",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/localize": "^19.2.14",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ng-select/ng-select": "^14.9.0",
    "@ngx-loading-bar/core": "^7.0.0",
    "@ngx-loading-bar/http-client": "^7.0.0",
    "@ngx-loading-bar/router": "^7.0.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.0",
    "@popperjs/core": "^2.11.8",
    "@tinymce/tinymce-angular": "^9.1.0",
    "angularx-qrcode": "^19.0.0",
    "bootstrap": "^5.3.3",
    "dayjs": "^1.11.13",
    "dropzone": "^6.0.0-beta.2",
    "file-saver": "^2.0.5",
    "keycloak-js": "^26.0.1",
    "ng2-date-picker": "^19.0.0",
    "ngx-dropzone-wrapper": "^17.0.0",
    "ngx-dynamic-hooks": "^3.1.0",
    "ngx-spinner": "^19.0.0",
    "rxjs": "~7.8.1",
    "sweetalert2": "^11.14.4",
    "tinymce": "^7.9.1",
    "tslib": "^2.8.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@types/jasmine": "~5.1.4",
    "@types/jasminewd2": "^2.0.13",
    "@types/node": "^22.7.7",
    "codelyzer": "^6.0.2",
    "jasmine-core": "~5.9.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ts-node": "^10.9.2",
    "tslint": "^6.1.3",
    "typescript": "~5.8.0"
  }
}
